<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height>
        <v-layout>

          <router-view></router-view>

        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>

import {mapState, mapActions} from 'vuex'

export default {
  name: 'App',
  components: {  },
  data: () => ({
    //
  }),
  computed:{
      ...mapState(['brands'])
  },
  methods:{
    ...mapActions(['fetchUsers','fetchBrands','fetchDepartments','fetchIssueMaster','fetchIssueTypes',
      'fetchIssueSubtypes','fetchAssignees','fetchSolutions','fetchSolutionTypes',
      'fetchSolutionMethods','fetchSections','fetchDiagnostics','fetchLocations',
      'fetchDiagnosticTypes']),
  },
  mounted(){
    console.log("Mounted App.vue")

  },
  created(){

    console.log("Created App.vue")
    this.$store.state.assignees = []
    this.$store.state.departments = []
    this.$store.state.sections = []
    this.$store.state.issueMaster = []
    this.$store.state.issueTypes = []
    this.$store.state.issueSubtypes = []
    this.$store.state.locations = []
    this.$store.state.sections = []
    this.$store.state.assignees = []
    this.$store.state.solutionTypes = []
    this.$store.state.solutions = []
    this.$store.state.solutionMethods = []
    this.$store.state.diagnostics = []
    this.$store.state.diagnosticTypes = []

    /*
    this.fetchUsers();
    this.fetchBrands();
    this.fetchDepartments();
    this.fetchIssueMaster();
    this.fetchIssueTypes();
    this.fetchIssueSubtypes();
    this.fetchAssignees();
    this.fetchSolutions();
    this.fetchSolutionTypes();
    this.fetchSolutionMethods();
    this.fetchSections();
    this.fetchDiagnostics();
    this.fetchDiagnosticTypes();
    this.fetchLocations();
    */

   this.$store.state.issuesBuffer.issues = []



  }
};
</script>
<style>


</style>